import { useEffect } from 'react';

// The icon in the browser tab and on a phone's home screen: the store's own mark, as Shopify shows a store's
// favicon, rather than the platform's placeholder index.html ships. A store that has not uploaded one keeps it.

/** The links a browser reads a page's icon from. */
const ICON_RELS = ['icon', 'apple-touch-icon'] as const;

// Points the page's icon links at the store's mark, adding a link the document does not have yet.
export function useStoreIcon(markUrl: string): void {
  useEffect(() => {
    if (!markUrl) return;
    for (const rel of ICON_RELS) {
      const link = document.head.querySelector<HTMLLinkElement>(`link[rel="${rel}"]`) ?? document.head.appendChild(Object.assign(document.createElement('link'), { rel }));
      link.removeAttribute('type');
      link.href = markUrl;
    }
  }, [markUrl]);
}
